
// Business information - replace placeholders with actual data
export const businessInfo = {
  name: "PK Landscape Associates",
  phone: "(203) 445-3594",
  phoneRaw: "2034453594",
  phoneInternational: "+12034453594",
  email: "hello@pklandscapect.com",
  address: {
    street: "1367 Boston Ave",
    city: "Bridgeport",
    state: "CT",
    zip: "06610",
    full: "1367 Boston Ave, Bridgeport, CT 06610"
  },
  serviceRadius: "30 miles",
  yearsInBusiness: "15+",
  licenses: "CT Home Improvement Contractor #HIC.0000000",
  insurance: "Fully insured with $2M liability coverage",
  reviewsSummary: "4.9 stars from 150+ reviews on Google",
  differentiators: [
    "Estate-level maintenance expertise",
    "Horticulture-trained crews",
    "Commercial SLA contracts",
    "Proactive site reporting",
    "Dedicated account managers"
  ],
  hours: {
    weekday: "7:00 AM - 6:00 PM",
    saturday: "8:00 AM - 2:00 PM",
    sunday: "Closed"
  },
  social: {
    facebook: "https://www.facebook.com/pklandscapect",
    instagram: "https://www.instagram.com/pklandscapect",
    linkedin: "https://www.linkedin.com/company/pklandscapect"
  }
};

// Schema.org LocalBusiness structured data
export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LandscapingBusiness",
  "name": businessInfo.name,
  "image": "https://pklandscapect.com/og-image.png",
  "url": "https://pklandscapect.com",
  "telephone": businessInfo.phone,
  "email": businessInfo.email,
  "address": {
    "@type": "PostalAddress",
    "streetAddress": businessInfo.address.street,
    "addressLocality": businessInfo.address.city,
    "addressRegion": businessInfo.address.state,
    "postalCode": businessInfo.address.zip,
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 41.1865,
    "longitude": -73.1952
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "07:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "08:00",
      "closes": "16:00"
    }
  ],
  "priceRange": "$$-$$$",
  "areaServed": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": 41.1865,
      "longitude": -73.1952
    },
    "geoRadius": "30 mi"
  },
  "sameAs": [
    businessInfo.social.facebook,
    businessInfo.social.instagram,
    businessInfo.social.linkedin
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Landscaping Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Landscape Maintenance",
          "description": "Weekly lawn care and property maintenance"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Landscape Design",
          "description": "Custom landscape design and installation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Hardscaping",
          "description": "Patios, walkways, retaining walls"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Snow Removal",
          "description": "Commercial and residential snow removal"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Irrigation",
          "description": "Irrigation system design and maintenance"
        }
      }
    ]
  }
});
